export { getScreenFromDeeplink } from './getScreenFromDeeplink'
export { generateLongFirebaseDynamicLink } from './generateLongFirebaseDynamicLink'
